// Central runtime configuration. Values come from Vite env vars (set in a .env file
// or the Cloudflare Pages build env) with sensible fallbacks.
//
// To enable provider (Google/Microsoft) sign-in, supply the Firebase web config below.
// Email/password sign-in needs none of it — only the API + CORS.
export const config = {
  /** Base URL of SnipCell.Api. */
  apiBaseUrl: (import.meta.env.VITE_API_BASE_URL as string) || 'https://api.snipcell.com',

  /** App version reported to the API in ClientInfo / usage telemetry. */
  appVersion: (import.meta.env.VITE_APP_VERSION as string) || '1.0.0',

  /** Web billing portal opened by the Upgrade / Manage-subscription button. */
  billingUrl: (import.meta.env.VITE_BILLING_URL as string) || 'https://accounts.snipcell.com',

  /**
   * Hard auth gate. While false, the app is usable without signing in (handy during
   * development and while CORS/Firebase are being wired). Flip to true once sign-in works
   * to require a session before using the add-in.
   */
  requireAuth: (import.meta.env.VITE_REQUIRE_AUTH as string) === 'true',

  /** Firebase web config — needed only for Google/Microsoft sign-in. */
  firebase: {
    apiKey: (import.meta.env.VITE_FIREBASE_API_KEY as string) || '',
    authDomain: (import.meta.env.VITE_FIREBASE_AUTH_DOMAIN as string) || '',
    projectId: (import.meta.env.VITE_FIREBASE_PROJECT_ID as string) || '',
    appId: (import.meta.env.VITE_FIREBASE_APP_ID as string) || '',
  },
}

/** True when enough Firebase config is present to attempt provider sign-in. */
export function isOAuthConfigured(): boolean {
  return Boolean(config.firebase.apiKey && config.firebase.authDomain)
}
